import { Provider } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { DatepickerTranslationConfig } from '../interfaces/datepicker-translations-config.interface';
import { DATEPICKER_TRANSLATION_CONFIG } from '../tokens/datepicker-translation-config.token';
import { DEFAULT_DATEPICKER_TRANSLATIONS } from '../constants/datepicker-translations.const';

export function provideDatepickerTranslationsWithNgxTranslate(): Provider {
	return {
		provide: DATEPICKER_TRANSLATION_CONFIG,
		useFactory: (translateService: TranslateService) => {
			const config: DatepickerTranslationConfig = {
				translations: DEFAULT_DATEPICKER_TRANSLATIONS,
				translateFn: (key: string, params?: any) => {
					return translateService.instant(key, params);
				},
			};
			return config;
		},
		deps: [TranslateService],
	};
}
